module.exports = __webpack_public_path__ + "static/media/install.1155d334.svg";